@if (isLoading()) {
    <div
        class="wk-app-loader__container"
        [class.wk-app-loader__container--button]="size === 'button'"
        [class.wk-app-loader__container--small]="size === 'small'"
        [class.wk-app-loader__container--large]="size === 'large'"
        [class.wk-app-loader__container--overlay]="isOverlay"
        [class.wk-app-loader__container--inline]="!isOverlay"
        [class.wk-app-loader__container__position--left]="position === 'left'"
    >
        <icon-pds3
            class="wk-app-loader__icon"
            [class.wk-app-loader__icon--white]="size === 'button'"
            [class.wk-app-loader__icon--small]="size === 'small'"
            [class.wk-app-loader__icon--large]="size === 'large'"
            name="wk-icon-spinner"
            [isSpin]="true"
        />
        @if (text) {
            <div class="wk-app-loader__container-title">{{ text | wkTranslate }}</div>
        }
    </div>
}
